import { reactReduxFirebase } from 'react-redux-firebase';
import { compose, createStore, applyMiddleware } from 'redux';
import makeRootReducer from '../reducers';
import firebase from 'firebase'
const createStoreWithMiddleware = applyMiddleware();

export const profilePopulates = [{ child: 'manager', root: 'projects' }];

const config = {
    userProfile: 'users', // where profiles are stored in database
    autoPopulateProfile: true,
    profileParamsToPopulate: profilePopulates
};

export default (initialState = { firebase: {} }) => {
    const store = createStore(
        makeRootReducer(),
        initialState,
        compose(
            reactReduxFirebase(firebase, config),
            createStoreWithMiddleware
        )
    );

    return store;
};


// WEBPACK FOOTER //
// ./src/store/store.js